import './Item.scss';

import React, { useCallback, useMemo } from 'react';

import Picture from '@/common/components/atoms/Picture/Picture';
import LinkLikeButton from '@/common/components/blocks/LinkLikeButton/LinkLikeButton';
// import {
//   REDIRECT_URI_KEY_PARAM,
//   REFRESH_TOKEN_KEY_PARAM,
//   ROUTE_AUTO_LOGIN,
//   ROUTE_ECATALOGS,
// } from '@/common/constants';
// import { useAuth } from '@/common/contexts/AuthContext';
import { useTagManager } from '@/common/contexts/TagManagerContext';
import formatSrcSet from '@/common/helpers/formatSrcSet';
import getImageBySize from '@/common/helpers/getImageBySize';
import { TAG_MANAGER } from '@/ebat/constants';

import { ItemDefaultProps, ItemPropTypes } from './Item.proptypes';

const Item = ({
  className,
  color,
  formats,
  // id,
  images,
  linkPdf,
  name,
  isHomePage,
}) => {
  const { onPushEvent } = useTagManager();
  // const { refreshToken } = useAuth();
  const classNames = useMemo(
    () => ['catalog', className].filter((val) => val).join(' '),
    [className],
  );

  const [isHovered, setIsHovered] = React.useState(false);

  /**
   * Push dataLayer
   * @type {function(): void}
   */
  const handlePushDataLayer = useCallback(
    () =>
      onPushEvent({
        event: TAG_MANAGER.EVENTS.PAGE_ECATALOG,
        catalog_name: name,
      }),
    [name, onPushEvent],
  );

  // const ecatalogUri = `${ROUTE_ECATALOGS}/${id}`;
  // const eCatalogAutoLoginUri = `${ROUTE_AUTO_LOGIN}?${REFRESH_TOKEN_KEY_PARAM}=${refreshToken}&${REDIRECT_URI_KEY_PARAM}=${ecatalogUri}`;

  return (
    <div
      className={classNames}
      data-qa-id="catalog-item"
      style={{
        backgroundColor: isHovered ? color : '#ffffff',
        transition: 'background-color 0.3s ease',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <LinkLikeButton
        className="catalog__link"
        context="catalog-link"
        url={linkPdf}
        onClick={handlePushDataLayer}
      >
        <div className="catalog__block" style={{ backgroundColor: color }}>
          {images?.length > 0 && (
            <Picture
              alt={images[0].alt}
              className="catalog__image"
              src={getImageBySize(
                images[0].url,
                formats[images[0].destination],
              )}
              srcSet={formatSrcSet(images, formats)}
            />
          )}
        </div>
        <h3
          className="catalog__title"
          style={{
            color:
              isHovered && !isHomePage && color !== '#ffffff'
                ? '#ffffff'
                : '#000000',
            transition: 'color 0.3s ease',
          }}
        >
          {name}
        </h3>
      </LinkLikeButton>
    </div>
  );
};

Item.defaultProps = {
  ...ItemDefaultProps,
};

Item.propTypes = {
  ...ItemPropTypes,
};

export default Item;
